import React, {Component} from 'react';
import {
    Form,
    Button,
    InputGroup,
    InputGroupAddon,
    Input,
    FormGroup,
    Label,
    FormFeedback, Alert, Row, Col
} from 'reactstrap';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import Constants from "../../inc/Constants";
import Swal from 'sweetalert2';
import LangContext from "../../providers/LangContext";
import {format} from 'date-fns';
import {nl} from 'date-fns/locale';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/pro-solid-svg-icons/faSpinner";

class BiddingModalBE extends Component {

    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            acceptance_date: null,
            view_date: null,
            offer: null,
            proviso: 'false',
            voorbeh_financiering: false,
            finance_amount: '',
            voorbeh_bouwk_keuring: false,
            bouwk_keuring_amount: "",
            voorbeh_nhg: false,
            voorbeh_overige: false,
            privacy_terms: false,
            gender: 'Dhr.',
            house_to_sell: null,
            remarks: '',
            purchase_broker: "",
            recaptcha: '',
            errors: {},
            succesResponse: '',
            succesModal: false,
            recapKey: 2,
            loading: false,
        };

        this.transferDateChange = this.transferDateChange.bind(this);
        this.visitDateChange = this.visitDateChange.bind(this);
        this.inputChange = this.inputChange.bind(this);
        this.inputNumericChange = this.inputNumericChange.bind(this);
        this.checkboxChange = this.checkboxChange.bind(this);
        this.submitBiddingForm = this.submitBiddingForm.bind(this);
        this.setRecapthaKey = this.setRecapthaKey.bind(this);
        this.CloseSuccesModal = this.CloseSuccesModal.bind(this);
        this.verifyEmail = this.verifyEmail.bind(this);

        this.initialState = this.state;
    }

    componentDidMount() {
        if (true === this.props.renderModal) {
            this.props.setModal(true);
        }
    }

    inputChange(e) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            ...prevState,
            [name]: value,
        }))
    }

    inputNumericChange(e){
        let value = e.target.value;
        let name = e.target.name;
        let isValid = /^[0-9]*$/.test(value);
        if(isValid) {
            this.setState({
                [name]: value,
            })
        }
    }

    checkboxChange(e) {
        let name = e.target.name;
        let value = e.target.checked;
        this.setState(prevState => ({
            [name]: value,
        }))
    }

    transferDateChange(date) {
        this.setState(prevState => ({
            acceptance_date: date,
        }))
    }

    visitDateChange(date) {
        this.setState(prevState => ({
            view_date: date
        }))
    }

    submitBiddingForm(event) {
        event.preventDefault();
        this.setState({loading: true});
        let self = this;
        let formDataJSON = {};
        let form = event.currentTarget;
        let data = new FormData(form);

        data.forEach((value, key) => {
            formDataJSON[key] = value;
        });
        formDataJSON['recaptcha'] = this.state.recaptcha;
        formDataJSON['view_date'] = (this.state.view_date) ? format(this.state.view_date, 'yyyy-MM-dd HH:mm:ss') : null;
        formDataJSON['acceptance_date'] = (this.state.acceptance_date) ? format(this.state.acceptance_date, 'yyyy-MM-dd HH:mm:ss') : null;

        axios({
            method: 'post',
            url: '/api/site/' + self.props.siteID + '/biddingform',
            data: formDataJSON,
        }).then(function (response) {
            Swal.fire({
                title: self.context.lang.get('sites.online_bidding_thank_you'),
                text: response.data.success,
                icon: 'success',
                timer: 3000
            })
            self.setState(prevState => ({
                ...self.initialState,
            }));
            self.props.setModal(false);
        }).catch(function (error) {
            self.setState(prevState => ({
                errors: error.response.data.errors,
                recapKey: self.state.recapKey + 1,
                loading: false,
            }));

        });
    }

    setRecapthaKey(val) {
        this.setState({recaptcha: val});
    }

    CloseSuccesModal(val) {
        this.setState({succesModal: false});
    }

    verifyEmail() {
        const errors = {...this.state.errors};
        if(this.state.email !== this.state.email_check) {
            errors['email_check'] = this.context.lang.get('validation.attributes.email_again_error');
            this.setState(prevState => ({
                errors,
            }));
            return;
        }

        delete errors.email_check;

        this.setState(prevState => ({
            errors,
        }));
    }

    render() {
        const visibleStyle = {display:'block'};
        let lang = this.context.lang;

        if (this.props.online_bidding == '0') {
            return null;
        }

        return (
            <Form onSubmit={this.submitBiddingForm}>
                {(this.props.customFormText && this.props.customFormText.length > 0) && (
                    <div dangerouslySetInnerHTML={{__html: this.props.customFormText}}></div>
                )}
                <h3>{lang.get('sites.your_bid').toUpperCase()} *</h3>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">€</InputGroupAddon>
                    <Input
                        invalid={!!this.state.errors?.offer}
                        placeholder={lang.get('sites.your_bid')}
                        name="offer"
                        value={this.state.offer}
                        onChange={this.inputNumericChange}
                        className="form-control"
                    />
                    <FormFeedback> {this.state.errors?.offer} </FormFeedback>
                </InputGroup>
                <p><small>{lang.get('sites.online_bidding_price_note')}</small></p>
                <div className="mt-2">
                    <h3>{lang.get('sites.online_bidding_reserved_be').toUpperCase()}</h3>
                    <div className="row mb-1">
                        <div className="col-1">
                            <Input
                                type="radio"
                                id="proviso_no"
                                name="proviso"
                                value="false"
                                className="ml-0"
                                checked={this.state.proviso == 'false'}
                                onChange={this.inputChange}/>
                        </div>
                        <div className="col-4">
                            <label htmlFor="proviso_no">{lang.get('sites.no')}</label>
                        </div>
                    </div>
                    <div className="row mb-1">
                        <div className="col-1">
                            <Input
                                type="radio"
                                id="proviso_yes"
                                name="proviso"
                                value="true"
                                className="ml-0"
                                checked={this.state.proviso == 'true'}
                                onChange={this.inputChange}
                            />
                        </div>
                        <div className="col-4">
                            <label htmlFor="proviso_yes">{lang.get('sites.yes')}</label>
                        </div>
                    </div>
                    <div
                        className={this.state.proviso == 'true' ? 'show-proviso proviso-inputs mb-4' : 'hide-proviso proviso-inputs'}>
                        <FormGroup check className="mb-1">
                            <Label check>
                                <Input
                                    type="checkbox"
                                    name="voorbeh_financiering"
                                    checked={this.state.voorbeh_financiering}
                                    onChange={this.checkboxChange}
                                />{' '}
                                {lang.get('sites.online_bidding_reserved_finance_be')}
                            </Label>
                        </FormGroup>
                        <div
                            className={this.state.voorbeh_financiering == true ? 'show-proviso proviso-inputs mb-2 mt-3' : 'hide-proviso proviso-inputs'}>
                            <div className='row mb-2'>
                                <div className='col-3'>
                                    <Label>
                                        {lang.get('sites.amount_weeks')}
                                    </Label>
                                </div>
                                <div className='col-9'>
                                    <div className="form-row">
                                        <div className="col-12">
                                            <Input
                                                invalid={!!this.state.errors?.finance_period}
                                                type="text"
                                                placeholder={lang.get('sites.amount_weeks')}
                                                name="finance_period"
                                            />
                                            <FormFeedback> {this.state.errors?.finance_period} </FormFeedback>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className='col-3'>
                                    <Label>
                                        {lang.get('sites.amount_to_financed')}
                                    </Label>
                                </div>
                                <div className='col-9'>
                                    <div className="form-row">
                                        <div className="col-12">
                                            <Input
                                                invalid={!!this.state.errors?.finance_amount}
                                                placeholder={lang.get('sites.amount_to_financed')}
                                                name="finance_amount"
                                                value={this.state.finance_amount}
                                                onChange={this.inputNumericChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row ">
                    <div className='col-md-3'>
                        {lang.get('sites.date_viewing')}
                    </div>
                    <div className='col-md-3'>
                        <DatePicker
                            selected={this.state.view_date}
                            onChange={this.visitDateChange}
                            locale={nl}
                            className="form-control"
                            placeholderText={lang.get('sites.date_viewing')}
                            dateFormat="dd-MM-yyyy"
                        />

                    </div>
                    <div className='col-md-3'>
                        {lang.get('sites.transfer_date')}<br/>
                    </div>
                    <div className='col-md-3'>
                        <DatePicker
                            selected={this.state.acceptance_date}
                            onChange={this.transferDateChange}
                            minDate={new Date()}
                            locale={nl}
                            className="form-control"
                            placeholderText={lang.get('sites.transfer_date')}
                            dateFormat="dd-MM-yyyy"
                        />

                    </div>
                    <div className='col-md-6'></div>
                    <div className='col-md-6'>
                        <small>{lang.get('sites.transfer_date_consultation')}
                        </small>
                    </div>
                </div>
                <br/>

                <h3>{lang.get('sites.your_information').toUpperCase()}</h3>

                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label check>
                            {lang.get('sites.name')} *
                        </Label>
                    </div>
                    <div className='col-md-9'>

                        <div className="form-row">
                            <div className="col-md-2">
                                <Input type="select"
                                       name="gender"
                                >
                                    <option value="m">{lang.get('sites.mr')}</option>
                                    <option value="v">{lang.get('sites.mrs')}</option>
                                </Input>
                            </div>
                            <div className="col-md-5">
                                <Input invalid={!!this.state.errors?.first_name} type="text"
                                       name="first_name"
                                       className="form-control"
                                       placeholder={lang.get('sites.first_name')}/>
                                <FormFeedback>{this.state.errors?.first_name}</FormFeedback>
                            </div>
                            <div className="col-md-5">
                                <Input invalid={!!this.state.errors?.last_name}
                                       type="text"
                                       name="last_name"
                                       className="form-control"
                                       placeholder={lang.get('sites.last_name')}
                                />
                                <FormFeedback>{this.state.errors?.last_name}</FormFeedback>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label check>
                            {lang.get('sites.name_partner_optional')}
                        </Label>
                    </div>
                    <div className='col-md-9'>

                        <div className="form-row">
                            <div className="col-md-2">
                                <Input type="select"
                                       name="gender_partner"
                                >
                                    <option value="v">{lang.get('sites.mrs')}</option>
                                    <option value="m">{lang.get('sites.mr')}</option>
                                </Input>
                            </div>
                            <div className="col-md-5">
                                <Input invalid={!!this.state.errors?.first_name_partner} type="text"
                                       name="first_name_partner"
                                       className="form-control"
                                       placeholder={lang.get('sites.first_name')}/>
                                <FormFeedback>{this.state.errors?.first_name_partner}</FormFeedback>
                            </div>
                            <div className="col-md-5">
                                <Input invalid={!!this.state.errors?.last_name_partner}
                                       type="text"
                                       name="last_name_partner"
                                       className="form-control"
                                       placeholder={lang.get('sites.last_name')}
                                />
                                <FormFeedback>{this.state.errors?.last_name_partner}</FormFeedback>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label check>
                            {lang.get('sites.address')} *
                        </Label>
                    </div>
                    <div className='col-md-9'>
                        <div className="form-row">
                            <div className="col-md-6">
                                <Input
                                    invalid={!!this.state.errors?.streetname}
                                    type="text"
                                    className="form-control"
                                    placeholder={lang.get('sites.streetname')}
                                    name="streetname"
                                />
                                <FormFeedback>{this.state.errors?.streetname}</FormFeedback>
                            </div>
                            <div className="col-md-6">
                                <Input invalid={!!this.state.errors?.streetnumber}
                                       type="text"
                                       className="form-control"
                                       placeholder={lang.get('sites.house_number')}
                                       name="streetnumber"
                                />
                                <FormFeedback>{this.state.errors?.streetnumber}</FormFeedback>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label>
                            {lang.get('sites.zipcode')} / {lang.get('sites.city')} *
                        </Label>
                    </div>
                    <div className='col-md-9'>

                        <div className="form-row">

                            <div className="col-md-6">
                                <Input
                                    invalid={!!this.state.errors?.zipcode}
                                    type="text"
                                    className="form-control"
                                    placeholder={lang.get('sites.zipcode')}
                                    name="zipcode"
                                />
                                <FormFeedback>{this.state.errors?.zipcode}</FormFeedback>
                            </div>
                            <div className="col-md-6">
                                <Input
                                    invalid={!!this.state.errors?.city}
                                    type="text"
                                    className="form-control"
                                    placeholder={lang.get('sites.city')}
                                    name="city"/>
                                <FormFeedback>{this.state.errors?.city}</FormFeedback>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label>
                            {lang.get('sites.country')} *
                        </Label>
                    </div>
                    <div className='col-md-9'>
                        <div className="form-row">
                            <div className="col-12">
                                <Input type="select" name="country">
                                    <option value="be">{lang.get('sites.belgium')}</option>
                                    <option value="nl">{lang.get('sites.netherlands')}</option>
                                    <option value="de">{lang.get('sites.germany')}</option>
                                </Input>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label>
                            {lang.get('sites.phone')} *
                        </Label>
                    </div>
                    <div className='col-md-9'>
                        <div className="form-row">
                            <div className="col-12">
                                <Input
                                    invalid={!!this.state.errors?.phone}
                                    type="text"
                                    placeholder={lang.get('sites.phone')}
                                    name="phone"/>
                                <FormFeedback>{this.state.errors?.phone}</FormFeedback>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label check>
                            {lang.get('sites.email')} *
                        </Label>
                    </div>
                    <div className='col-md-9'>
                        <div className="form-row">
                            <div className="col-12">
                                <Input invalid={!!this.state.errors?.email}
                                       type="email"
                                       placeholder={lang.get('sites.email')}
                                       name="email"
                                       onChange={this.inputChange}
                                />
                                <FormFeedback>{this.state.errors?.email}</FormFeedback>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label check>
                            {lang.get('sites.email_again')} *
                        </Label>
                    </div>
                    <div className='col-md-9'>
                        <div className="form-row">
                            <div className="col-12">
                                <Input invalid={!!this.state.errors?.email_check}
                                       type="email"
                                       placeholder={lang.get('sites.email_again')}
                                       name="email_check"
                                       onChange={this.inputChange}
                                       onBlur={this.verifyEmail}
                                />
                                <FormFeedback>{this.state.errors?.email_check}</FormFeedback>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-3 mt-1">
                        <Label check>{lang.get("sites.house_to_sell_question")}</Label>
                    </div>
                    <div className="col-md-9 align-self-center">
                        <FormGroup check inline={true} className="my-2">
                            <Label check className="mr-2">
                                <Input
                                    type="radio"
                                    id="house_to_sell_yes"
                                    name="house_to_sell"
                                    value="true"
                                    checked={this.state.house_to_sell == "true"}
                                    onChange={this.inputChange}
                                />{" "}
                                {lang.get("sites.yes")}
                            </Label>
                        </FormGroup>
                        <FormGroup check inline={true} className="my-2">
                            <Label check className="mr-2">
                                <Input
                                    type="radio"
                                    id="house_to_sell_no"
                                    name="house_to_sell"
                                    value="false"
                                    checked={this.state.house_to_sell == "false"}
                                    onChange={this.inputChange}
                                />{" "}
                                {lang.get("sites.no")}
                            </Label>
                        </FormGroup>
                        <div className="w-100">
                            {!!this.state.errors?.house_to_sell && <p className="small text-danger">{this.state.errors?.house_to_sell}</p>}
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className='col-md-3'>
                        <Label check>
                            {lang.get('sites.remarks')}
                        </Label>
                    </div>
                    <div className='col-md-9'>
                        <div className="form-row">
                            <div className="col-12">
                                <Input type="textarea"
                                       invalid={!!this.state.errors?.remarks}
                                       placeholder={lang.get('sites.online_bidding_remarks_optional_be')}
                                       name="remarks"
                                />
                                <FormFeedback> {this.state.errors?.remarks} </FormFeedback>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className='col-md-12'>
                        <FormGroup className="mr-1 mt-3" check>
                            <Label check>
                                <Input
                                    invalid={!!this.state.errors?.privacy_terms}
                                    type="checkbox"
                                    name="privacy_terms"
                                    value={this.state.privacy_terms}
                                    onChange={this.checkboxChange}/>{' '}
                                {lang.get('sites.bieding_terms_before')} <span dangerouslySetInnerHTML={{__html: lang.get('sites.bieding_terms_url', {termsLink: this.props.terms})}} />. {lang.get('sites.bieding_terms_after')}
                                <FormFeedback>{this.state.errors?.privacy_terms}</FormFeedback>
                            </Label>
                        </FormGroup>
                    </div>
                </div>
                <div className="row">
                    <FormGroup className="col-md-12 mt-2">
                        <ReCAPTCHA
                            sitekey={Constants.RECAPTHCA_KEY.siteKey}
                            onChange={this.setRecapthaKey}
                            key={this.state.recapKey}
                            theme={(this.props.theme === 'v1') ? 'dark' : 'light'}
                        />{' '}{!!this.state.errors?.recaptcha && <div className="invalid-feedback" style={visibleStyle}>{this.state.errors?.recaptcha}</div>}
                    </FormGroup>
                </div>
                <div className="row">
                    <div className="col">
                        <p><small dangerouslySetInnerHTML={{__html: lang.get('sites.online_bidding_disclaimer_be')}}></small></p>
                    </div>
                </div>
                {Object.keys(this.state.errors).length > 0 &&
                    <Alert color="danger">
                        {lang.get('sites.bidding_form_has_errors')}
                    </Alert>
                }
                <hr/>
                <div className="d-flex justify-content-between">
                    <Button color="secondary" onClick={()=>this.props.closeModal()}>
                        {lang.get("sites.cancel")}
                    </Button>
                    <Button className="btn btn-primary" type="submit">
                        {this.state.loading && (
                            <FontAwesomeIcon icon={faSpinner} spin />
                        )}{" "}
                        {lang.get("sites.place_bid")}{" "}
                    </Button>
                </div>
            </Form>
        )
    }
}

export default BiddingModalBE;
